export const SummerBookingRef: { [id: number]: { Short: string, Long: string }; } = {
    999: {
        Short: "Summer booking not open",
        Long: "Summer vacation accommodation bookings are currently closed. You cannot apply for this accommodation type at this time."
    },
    600: {
        Short: "Outside booking date",
        Long: "Sorry you are not eligible to apply for Summer Vacation Accommodation at the current time as you are not a current or recent student."
    },
    680: {
        Short: "Wrong Campus",
        Long: "Sorry you are not eligible to apply for Summer Vacation Accommodation at the current time as you are not studying on an eligible campus."
    },
    666: {
        Short: "Not in current cand year",
        Long: "Sorry you are not eligible to apply for Summer Vacation Accommodation at the current time."
    },
    678: {
        Short: "Colchester Summer Vacation Bookings Closed",
        Long: "Sorry you are not eligible to apply for Summer Vacation Accommodation at the current time as summer booking for Colchester campus is currently closed."
    },
    178: {
        Short: "Colchester Summer Vacation Booking",
        Long: ""
    },
    679: {
        Short: "Southend Summer Vacation Bookings Closed",
        Long: "Sorry you are not eligible to apply for Summer Vacation Accommodation at the current time as summer booking for Southend campus is currently closed."
    },
    179: {
        Short: "Southend Summer Vacation Booking",
        Long: ""
    }
};  